import { useNavigate } from 'react-router-dom';
import DashboardLayout from '@/pages/dashboard/components/DashboardLayout';
import CourseForm from '@/pages/dashboard/courses/components/CourseForm';
import { useAuth } from '@/context/AuthContext';

function CourseNew() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">Nouvelle formation</h1>
        <p className="text-sm text-foreground-400 mt-1">
          Publiez une formation en ligne et touchez des apprenants partout en Afrique.
        </p>
      </div>

      <div className="max-w-3xl">
        <CourseForm ownerId={user.id} onSaved={() => navigate('/dashboard/courses')} />
      </div>
    </DashboardLayout>
  );
}

export default CourseNew;